
export const FILTER_INNER_DROP_SHADOW_ID = 'filter-inner-drop-shadow';

export const FilterInnerDropShadow: React.FC = () => (
  <filter id={FILTER_INNER_DROP_SHADOW_ID}>
    <feComponentTransfer in="SourceAlpha">
      <feFuncA type="table" tableValues="1 0" />
    </feComponentTransfer>
    <feGaussianBlur stdDeviation="2" />
    <feOffset dx="0" dy="3" result="OFFSET_BLUR" />
    <feFlood floodColor="rgba(255, 255, 255, 0.3)" result="color" />
    <feComposite in2="OFFSET_BLUR" operator="in" />
    <feComposite in2="SourceAlpha" operator="in" />
    <feMerge>
      <feMergeNode in="SourceGraphic" />
      <feMergeNode />
    </feMerge>
  </filter>
);
